import React from 'react'
import TypeWriter from "react-typewriter";

function Portfolio() {
  return (
    <div>
      <TypeWriter className="gaming-font skill-text" typing={0.5}>Projects</TypeWriter>
      <br/>
      <br/>
      <div  >
        <div class="card col span-1-of-3 ">
                  <img src='https://res.cloudinary.com/codegowdacloud/image/upload/v1628059479/Screenshot_2021-08-03_at_10.14.07_PM_y2cb2g.png' alt="" class="card__img image"></img>
                  <div class="card__data">
                      <h1 class="card__title logo__one ">Audible Clone</h1>
                      <span class="card__price bg-black ">Next.js, Tailwind.css, Google Books API</span>
                      <p class="card__description">This is an open-source project that we built which was a clone of Amazon Audible. For the books we have implemented Google Books API.  </p>
                      <a href='https://audible.vercel.app/' target='_blank' class="card__button">Hosted Site</a>
                      <br></br>
                      <a href='https://github.com/Arjun-Joshi20/audible' target='_blank' class="card__button">Github Repo</a>
                  </div>
          </div>
          <div class="card col span-1-of-3 ">
                  <img src='https://res.cloudinary.com/codegowdacloud/image/upload/v1628065692/Screenshot_2021-08-04_at_1.58.04_PM_s2doxb.png' alt="" class="card__img image"></img>
                  <div class="card__data">
                      <h1 class="card__title logo__one ">Apple Clone</h1>
                      <span class="card__price bg-black ">Next.js, Tailwind.css, Google Books API</span>
                      <p class="card__description">This is an open-source project that we built which was a clone of Amazon Audible. For the books we have implemented Google Books API.  </p>
                      <a href='https://apple-clone-tau.vercel.app/' target='_blank' class="card__button">Hosted Site</a>
                      <br></br>
                      <a href='https://github.com/Arjun-Joshi20/apple-website-clone' target='_blank' class="card__button">Github Repo</a>
                  </div>
          </div>
          <div class="card col span-1-of-3 ">
                  <img src='https://res.cloudinary.com/codegowdacloud/image/upload/v1628066990/Screenshot_2021-08-04_at_2.19.39_PM_xb3beo.png' alt="" class="card__img image"></img>
                  <div class="card__data">
                      <h1 class="card__title logo__one ">Gaming E-Commerce Website</h1>
                      <span class="card__price bg-black "> Next.js, Redux, Tailwind.css</span>
                      <p class="card__description">This is an E-Commerce Website which sells gaming products.</p>
                      <a href='https://drive.google.com/file/d/1ZBxuZfzNm9BGgWFWYyT2mLHvfub8wC7X/view?usp=sharing' target='_blank' class="card__button">Project Video</a>
                      <br></br>
                      <a href='https://github.com/Arjun-Joshi20/game-world-ecommerce' target='_blank' class="card__button">Github Repo</a>
                  </div>
          </div>
      </div>
    </div>
  )
}

export default Portfolio
